import { BASE_ENDPOINT } from "../../endpoint";

/**
 * Fetches the current wallet balance and last-funded date for a company.
 *
 * @param {string} TOKEN - bearer auth token
 * @param {string|number} companyId
 * @returns {Promise<{walletId:number, companyId:number, companyName:string, balance:number, dateOfLastFunding:string}>}
 */
export const getWalletInfo = async (TOKEN, companyId) => {
  try {
    const response = await fetch(
      `${BASE_ENDPOINT}/api/Wallets/${companyId}/info`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      },
    );

    console.log("Token:", TOKEN);
    console.log("Company ID:", companyId);
    const res = await response.json();
    if (!response.ok) {
      console.error("Error:", res);
      throw new Error(res.message || "Failed to fetch wallet info");
    }
    return res?.data;
  } catch (error) {
    console.error("API fetch error:", error);
    throw error;
  }
};
